import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';
import OptionInfo from './OptionInfo';
import withSubscription from './withSubscription';
import context from './api/context';

const styles = () => ({
  header: {
    textAlign: 'center',
    padding: 10
  },
  cell: {
    padding: 10
  },
  price: {
    padding: 10,
    textAlign: 'center'
  },
  row: {
    height: '40px'
  }
});

class StrikesTable extends Component {
  state = {}

  render() {
    const { pair, select, selected, strikes, price, classes } = this.props;
    const selectedStyle = { backgroundColor: 'yellow' };

    const StrikeCell = ({ type, strike, children }) => {
      var style = {}
      if (selected && selected.type === type && selected.strike === strike) {
        style = selectedStyle;
      } else if (strike.price.gt(price.price) ? type === 'put' : type === 'call') {
        style = { backgroundColor: '#F5F5F5' };
      }
      return <TableCell style={style} onClick={()=>select({type, strike})} numeric className={classes.cell}>{children}</TableCell>
    }

    const optionCells = (strike, type) => {
      return (<OptionInfo option={strike[type].address}>
        {(info) => {
          if(info) {
            return [
            <StrikeCell key={0} type={type} strike={strike}>{info.total.toString()}</StrikeCell>,
            <StrikeCell key={1} type={type} strike={strike}>{info.balance.toString()}</StrikeCell>,
            <StrikeCell key={2} type={type} strike={strike}>{info.outstanding.toString()}</StrikeCell>
          ];

          } else {
            return [
            <StrikeCell key={0} type={type} strike={strike}>{0}</StrikeCell>,
            <StrikeCell key={1} type={type} strike={strike}>{0}</StrikeCell>,
            <StrikeCell key={2} type={type} strike={strike}>{0}</StrikeCell>
          ];
        }
        }}
        </OptionInfo>)
    }

    return (
      <Table style={({marginTop:'10px'})}>
        <TableHead>
          <TableRow className={classes.row}>
            <TableCell className={classes.header} colSpan={3}/>
            <TableCell className={classes.header}>
              <span>{price && price.price && price.price.toFixed(Math.min(pair.currency.decimals, 5))}</span>
            </TableCell>
            <TableCell className={classes.header} colSpan={3}/>
          </TableRow>
          <TableRow className={classes.row}>
            <TableCell className={classes.header} colSpan={3}>Call</TableCell>
            <TableCell className={classes.header} rowSpan={2}>Price</TableCell>
            <TableCell className={classes.header} colSpan={3}>Put</TableCell>
          </TableRow>
          <TableRow className={classes.row}>
            <TableCell className={classes.header}>Total</TableCell>
            <TableCell className={classes.header}>Holding</TableCell>
            <TableCell className={classes.header}>Outstanding</TableCell>

            <TableCell className={classes.header}>Total</TableCell>
            <TableCell className={classes.header}>Holding</TableCell>
            <TableCell className={classes.header}>Outstanding</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {strikes.strikes.map((strike, i) => (
              <TableRow className={classes.row} key={i}>
                {optionCells(strike, 'call')}
                <TableCell className={classes.price} numeric style={(selected && selected.strike === strike ? selectedStyle : {})}>{strike.price.toFixed(Math.min(5, pair.currency.decimals))}</TableCell>
                {optionCells(strike, 'put')}
              </TableRow>
          ))}
        </TableBody>
      </Table>
    )
  }
}

export default withStyles(styles)(withSubscription(({ pair, date }) => ({
  price: context.prices(pair),
  strikes: context.strikes(pair, date)
}))(StrikesTable));


// WEBPACK FOOTER //
// ./src/StrikesTable.js